import { render, staticRenderFns } from "./EventDiscountSetting.vue?vue&type=template&id=4ff4f8cd"
import script from "./EventDiscountSetting.vue?vue&type=script&lang=js"
export * from "./EventDiscountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports